import { useLocation } from "react-router-dom";
import { parseQueryString } from "lib/general-helpers";

export const useQueryParams = () => {
  const location = useLocation();
  const { search } = location;
  return parseQueryString(search);
};
